import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.css']
})
export class SpinnerComponent implements OnInit {

    @Input() public message;
    @Input() public successErrorMessgae: string = "";

  constructor() { }

    ngOnInit() {
        
  }

}



// WEBPACK FOOTER //
// D:/a/1/s/Uhm.Loops.Web/src/app/spinner/spinner.component.ts